import Home from 'assets/icons/home.svg';
import Profile from 'assets/icons/profile-white.svg'
import Calendar from 'assets/icons/calendar-hex-icon.svg'
import Wallet from 'assets/icons/wallet-hex-icon.svg'

export const headerContent = {
  '/': {
    title: 'Home',
    image_url: Home
  },
  '/perfil': {
    title: 'Perfil',
    image_url: Profile
  },
  '/perfil-pessoal': {
    title: 'Perfil',
    image_url: Profile
  },
  '/perfil-profissional': {
    title: 'Perfil',
    image_url: Profile
  },
  '/perfil-web': {
    title: 'Perfil',
    image_url: Profile
  },
  '/termos-de-uso': {
    title: 'Termos de uso',
    image_url: ''
  },
  '/suporte': {
    title: 'Suporte',
    image_url: ''
  },
  '/historico': {
    title: 'Histórico de chamados',
    image_url: ''
  },
  '/agenda': {
    title: 'Minha Agenda',
    image_url: Calendar
  },
  '/ganhos': {
    title: 'Meus ganhos',
    image_url: Wallet
  },
  '/servicos': {
    title: 'Meus preços',
    image_url: '',
  }
}
